/**
 * 通用数字输入组件
 */
import React from 'react';

interface NumberInputProps {
  label: string;
  value: number;
  onChange: (val: number) => void;
  min: number;
  max: number;
  hint?: string;
  step?: 'int' | 'float';
}

export default function NumberInput({
  label, value, onChange, min, max, hint, step,
}: NumberInputProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <input
        type="number"
        step={step === 'float' ? '0.1' : '1'}
        value={value}
        onChange={(e) => {
          const val = step === 'float' ? parseFloat(e.target.value) : parseInt(e.target.value, 10);
          if (!isNaN(val) && val >= min && val <= max) onChange(val);
        }}
        min={min}
        max={max}
        className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
      />
      {hint && <p className="mt-1 text-xs text-gray-400">{hint}</p>}
    </div>
  );
}
